<template>
    <Box :title="'设备归还申请('+Total+'台)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">

            <div class="items" v-for="item in items">
                <div>
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <p class="ellipsis">{{item.SBMC}}</p>
                        <div>
                            <div>
                                <p>资产编号：</p>
                                <p>申请科室：</p>
                                <p>规格型号：</p>
                                <p>资产序列号：</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{item.SBBH}}</p>
                                <p class="ellipsis">{{item.SQKSMC}}</p>
                                <p class="ellipsis">{{item.SBXH}}</p>
                                <p class="ellipsis">{{item.SBXLH}}</p>
                            </div>
                        </div>
                    </div>
                    <div @click="jump(item)"></span>申请归还</div>
                </div>
                <div>
                    <span class="ellipsis">申请人:{{item.SQRMC}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;申请日期:{{DateFormat(item.SQRQ)}}</span>
                    <span class="ellipsis">设备号数:{{item.SBHS||'暂无'}}</span>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div key='1' class="menu" v-show="IsSee" transiton="fade">
                <div class="items">
                    <span>设备名称</span>
                    <input type="text" placeholder="请输入设备名称" v-model="SBMC">
                </div>
                <div class="items">
                    <span>规格型号</span>
                    <input type="text" placeholder="请输入规格型号" v-model="SBXH">
                </div>
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    import Box from '@/components/commonBox/commonBox'
    import {
        format
    } from '../../../tool/Date.js'
    export default {
        name: 'DeployGiveList',
        data() {
            return {
                SBMC: '',
                SBXH: '',
                limit: 5,
                loading: true,
                finished: false,
                IsLoad: true,
                items: [{

                }],
                IsSee: false,
                touchStartY: 0,
                Total: 0
            }
        },
        components: {
            Box,
            LoadingFooter
        },
        activated() {
            this.limit=5;
            this.LoadData();
        },
        methods: {
            serach() {
                this.limit=5;
                this.IsSee=false;
                this.LoadData();
            },
            jump(obj) {
                this.$router.push({
                    path: '/DeployGiveDefault',
                    query: {
                        Equipment: obj
                    }
                })
            },
            LoadData() {
                this.$get('api/DeployEquipment/GetDeployGiveList', {
                        SBMC: this.SBMC,
                        SBXH: this.SBXH,
                        GKHM: this.$UserInfo.UserId,
                        STORE: this.$UserInfo.StoreCode,
                        limit: this.limit
                    })
                    .then(result => {
                        this.Total = result.Total;
                        this.items = result.Rows;
                        if (this.Total <= this.limit) {
                            this.loading = false;
                            this.finished = true;
                        } else this.loading = false;
                    })
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.limit += 5;
                    this.LoadData();
                }
            },
            onScroll(value) {
                if (value > this.touchStartY) {
                    this.touchStartY = value;
                    this.IsSee = false;
                } else if ((this.touchStartY - value) > 20) {
                    this.touchStartY = value
                    this.IsSee = true;
                }
            },
            DateFormat(obj) {
                return format(obj, 'YYYY-MM-DD');
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        height: 364px;
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;

                        &>p {
                            color: $TEXT-DARK-COLOR;
                            font-weight: bold;
                            font-size: 32px;
                            margin-bottom: 18px;
                            width: 330px;
                        }

                        &>div {
                            display: flex;

                            p {
                                color: #999;
                                font-size: 26px;
                                line-height: 45px;
                                height: 45px;
                            }

                            &>div {
                                &:last-child {
                                    p {
                                        width: 170px;
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        margin-left: 35px;
                        width: 152px;
                        height: 61px;
                        background: $THEME-COLOR;
                        border-radius: 30px;
                        text-align: center;
                        line-height: 61px;
                        font-size: 26px;
                        color: $TEXT-LIGHT-COLOR;
                        margin-top: 103px;
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/page/DeployGiveList/DeployGiveList.vue